import { useContext, useEffect, useState } from "react";
import "./Demo.css";
import SingleCustomerTranscript from "./SingleTranscript";
import BulkedUpload from "./BulkedUpload";
import { Context } from "../../utils/context";

const Demo = () => {
  const { data, setdata,loading,setLoading } = useContext(Context);
  const handleUpload = (e) => {
    e.preventDefault();
    setLoading(true);
    fetch("http://abc.cardboardpackage.com/upload", {
      method: "POST",
      body: new FormData(e.target),
    })
      .then((res) => {
        setLoading(false);
        return res.json();
      })
      .then((data) => setdata(data))
      .catch((e) => {
        setLoading(false);
        alert(
          "Your Request Has Failed Due to Network Problem.Please Try Again"
        );
        console.log(e);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    fetch("http://abc.cardboardpackage.com/get_data_single_transcript", {
      method: "POST",
      body: new FormData(e.target),
    })
      .then((res) => {
        setLoading(false);
        return res.json();
      })
      .then((data) => setdata(data))
      .catch((e) => {
        setLoading(false);
        alert(
          "Your Request Has Failed Due to Network Problem.Please Try Again"
        );
        console.log(e);
      });
  };
  const [bulk, setBulk] = useState(false);
  useEffect(() => {
    document
      .getElementById("Bulked")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    document
      .getElementById("analysis")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
  }, [loading]);
  return (
    <>
      <div className="demo" id="demo">
        <h1>
          <span>RealTalk</span> Live Demo
        </h1>

        {bulk ? (
          <form
            onSubmit={handleUpload}
            encType="multipart\form-data"
            title="Each Transcript Takes almost 2 mins."
          >
            <input type="file" name="file" accept=".csv" required />
            <div className="button">
              <div>
                <label htmlFor="bulk">Bulk Upload (CSV Only)</label>
                <label className="switch">
                  <input type="checkbox" id="bulk" />
                  <span
                    className="slider round"
                    onClick={() => setBulk((prev) => !prev)}
                  ></span>
                </label>
              </div>
              {loading ? (
                <div className="loading"></div>
              ) : (
                <input className="generate" value="Generate" type="submit" />
              )}
            </div>
          </form>
        ) : (
          <form
            onSubmit={handleSubmit}
            title="Each Transcript Takes almost 2 mins."
          >
            <textarea
              name="transcript"
              placeholder="Enter your transcript.."
              required
            ></textarea>

            <div className="button">
              <div>
                <label htmlFor="bulk">Bulk Upload (CSV Only) </label>
                <label className="switch">
                  <input type="checkbox" id="bulk" />
                  <span
                    className="slider round"
                    onClick={() => setBulk((prev) => !prev)}
                  ></span>
                </label>
              </div>
              {loading ? (
                <div className="loading"></div>
              ) : (
                <input className="generate" value="Generate" type="submit" />
              )}
            </div>
          </form>
        )}
        {data.Bulked && <BulkedUpload data={data} />}
        {data.AgentEmotions && <SingleCustomerTranscript data={data} />}
      </div>
    </>
  );
};

export default Demo;
